import { combineReducers } from 'redux'

import initialState from './initial_state'
import {
  INIT,
  SET_SEARCH_VALUE,
  SET_SEARCH_HIGHLIGHTED_INDEX,
  OPEN_SEARCH_MENU,
  CLOSE_SEARCH_MENU,
  SET_SEARCH_STATE
} from './constants'
import { SearchState } from './types'

export default combineReducers({
  byId: (state = initialState.byId, action: any) => {
    let handlers: any = {
      [INIT]: (state: any, payload: any) => {
        return {
          ...state,
          [payload.id]: {
            id: payload.id,
            searchState: SearchState.NOT_STARTED,
            value: null, // Start null (so that know when to either select an option or when to clear searchValue)
            selectedIndex: null,
            highlightedIndex: 0,
            menuOpen: false
          }
        }
      },
      [SET_SEARCH_STATE]: (state: any, payload: any) => {
        return {
          ...state,
          [payload.id]: {
            ...state[payload.id],
            searchState: payload.searchState
          }
        }
      },
      [SET_SEARCH_VALUE]: (state: any, { id, value }: { id: string; value: string | null }) => {
        return {
          ...state,
          [id]: {
            ...state[id],
            value,
            menuOpen: value && value.length > 0
          }
        }
      },
      [SET_SEARCH_HIGHLIGHTED_INDEX]: (state: any, payload: any) => {
        return {
          ...state,
          [payload.id]: {
            ...state[payload.id],
            highlightedIndex: payload.index
          }
        }
      },
      [OPEN_SEARCH_MENU]: (state: any, payload: any) => {
        return {
          ...state,
          [payload.id]: {
            ...state[payload.id],
            menuOpen: true
          }
        }
      },
      [CLOSE_SEARCH_MENU]: (state: any, payload: any) => {
        return {
          ...state,
          [payload.id]: {
            ...state[payload.id],
            menuOpen: false
          }
        }
      }
    }

    let handler = handlers[action.type]

    if (typeof handler === 'function') {
      return handler(state, action.payload)
    }

    return state
  }
})
